<app-list-view
  [service]="resibesService"
  [disableEdit]="true"
  [url]="'editResibe'"
  [newUrl]="'recipes/editRecipe/0'"
  [displayedColumns]="[
    'id',
    'name',
    'description',
    'cooktimeS',
    'oventimeS',
    'timeSpentInKichenS',
    'totalTimeS',
  ]"
></app-list-view>
